module.exports = __webpack_public_path__ + "static/media/applogo_light.29c22bba.svg";